import { loadView } from '@/router'

export default [
  {
    path: 'tracking',
    name: 'freight-tracking',
    component: loadView('Application/Freight/TrackingNew'),
    showInAlfred: true,
    alfredTitle: 'Freight - Tracking'
  }
]
